























































import Vue from 'vue'
import moment from 'moment-timezone'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { MutationNames, ActionNames, GetterNames } from '@/store/modules/shift-report/keys'
import { generatePdfFromHtml } from '@/utils/pdf-export'
import { ExportDialogs } from '@/constants/exports'
import { Timeouts } from '@/constants/timeouts'
import { ShiftReportShiftPeriods as ShiftPeriods } from '@/constants/shift-and-round-reports'
import ShiftReportTable from '@/components/shift-and-round-reports/tables/ShiftReportTable.vue'
import IsGeneratingExportDialog from '@/components/dialog/IsGeneratingExportDialog.vue'

export default Vue.extend({
  components: {
    ShiftReportTable,
    IsGeneratingExportDialog,
  },

  data() {
    return {
      isFetchingReportData: false,
      shiftPeriodOptions: {
        [ShiftPeriods.Morning]: {
          name: ShiftPeriods.Morning,
          sourceDataStartTime: {
            time: '23:00',
            previousDay: true,
          },
          sourceDataEndTime: {
            time: '07:00',
          },
        },
        [ShiftPeriods.Afternoon]: {
          name: ShiftPeriods.Afternoon,
          sourceDataStartTime: {
            time: '07:00',
          },
          sourceDataEndTime: {
            time: '15:00',
          },
        },
        [ShiftPeriods.Evening]: {
          name: ShiftPeriods.Evening,
          sourceDataStartTime: {
            time: '15:00',
          },
          sourceDataEndTime: {
            time: '23:00',
          },
        },
      },
      chosenDate: moment().format('YYYY-MM-DD'),
      chosenShiftPeriod: ShiftPeriods.Morning,
      isGeneratingExport: false,
      isGeneratingExportDialogText: ExportDialogs.Pdf,
    }
  },

  computed: {
    formattedChosenDate() {
      return moment(this.chosenDate).format('dddd, MMMM Do, YYYY')
    },
    timestampsForGetRequest() {
      const { sourceDataStartTime, sourceDataEndTime } = this.shiftPeriodOptions[this.chosenShiftPeriod]
      const startTimestamp = sourceDataStartTime.previousDay
        ? moment(`${this.chosenDate}T${sourceDataStartTime.time}`)
            .subtract(1, 'days')
            .valueOf()
        : moment(`${this.chosenDate}T${sourceDataStartTime.time}`).valueOf()
      const endTimestamp = moment(`${this.chosenDate}T${sourceDataEndTime.time}`).valueOf()
      return {
        startTimestamp,
        endTimestamp,
      }
    },
    chosenShiftPeriodTimes() {
      return this.shiftPeriodOptions[this.chosenShiftPeriod]
    },
    shiftRadioOptions() {
      return [
        {
          label: 'Morning shift',
          value: ShiftPeriods.Morning,
        },
        {
          label: 'Afternoon shift',
          value: ShiftPeriods.Afternoon,
        },
        {
          label: 'Evening shift',
          value: ShiftPeriods.Evening,
        },
      ].map(opt => ({
        ...opt,
        isActive: this.chosenShiftPeriod === opt.value,
      }))
    },
    shiftReport() {
      return this[GetterNames.shiftReport][0]
    },
    combinedEvents() {
      if (this.shiftReport) {
        return [...this.shiftReport.incidents, ...this.shiftReport.risks]
      }
      return []
    },
    ...mapGetters(ModuleNames.shiftReport, [
      GetterNames.shiftReport,
      GetterNames.chosenDate,
      GetterNames.chosenShiftPeriod,
    ]),
  },

  watch: {
    timestampsForGetRequest: {
      deep: true,
      async handler() {
        this.setDateParamsInStore()
        await this.getShiftReport()
      },
    },
  },

  async mounted() {
    if (!this[GetterNames.chosenDate] || !this[GetterNames.chosenShiftPeriod]) {
      this.setDateParamsInStore()
      await this.getShiftReport()
    } else {
      this.chosenDate = this[GetterNames.chosenDate]
      this.chosenShiftPeriod = this[GetterNames.chosenShiftPeriod]
    }
  },

  methods: {
    exportCsvForChosenShift() {
      console.log('export shift')
    },
    async exportPdfForChosenShift() {
      this.isGeneratingExport = true
      await generatePdfFromHtml({
        filename: `Agartee Shift Report (${this.formattedChosenDate} - ${this.chosenShiftPeriod})`,
        source: this.$refs.shiftReportTable,
        pagebreak: { avoid: 'tr' },
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async getShiftReport() {
      this.isFetchingReportData = true
      await this[ActionNames.getShiftReportByTimestamps]({
        starttimestamp: this.timestampsForGetRequest.startTimestamp,
        endtimestamp: this.timestampsForGetRequest.endTimestamp,
      })
      this.isFetchingReportData = false
    },
    setDateParamsInStore() {
      this[MutationNames.updateChosenDate](this.chosenDate)
      this[MutationNames.updateChosenShiftPeriod](this.chosenShiftPeriod)
    },
    ...mapMutations(ModuleNames.shiftReport, [MutationNames.updateChosenDate, MutationNames.updateChosenShiftPeriod]),
    ...mapActions(ModuleNames.shiftReport, [ActionNames.getShiftReportByTimestamps]),
  },
})
